import * as React from 'react';
import { DOM_IDS, HTML_CLASSES } from '../../../../../constants/product.constants';
import { useProductContext } from '../../../../../contexts/ProductContext';

export const ProductHeader: React.FC = () => {
    const { selectedProductInformation, productConfig } = useProductContext();

    const name = selectedProductInformation.name || productConfig.name;
    const sku = {
        label: productConfig.sku?.label,
        value: selectedProductInformation.sku || productConfig.sku?.value || '',
    };
    const preTitle = productConfig.preTitle;
    return (
        <div>
            <p className={HTML_CLASSES.LAYOUT_PRODUCT_CODE}>
                <span id={DOM_IDS.PRODUCT_SKU}>{sku?.value}</span>
            </p>
            <h1>
                {preTitle && preTitle !== '0' && (
                    <>
                        <span className={HTML_CLASSES.PRE_TITLE}>{preTitle}</span>
                        &nbsp;
                    </>
                )}
                {name}
            </h1>
        </div>
    );
};
